/* eslint-disable import/no-cycle */
import { i18n } from '@/boot/i18n';
import SsoService from '@/services/sso';
import ErrorHandler from '@/tools/errorHandler';
import { formatDateTime } from '@/utils/date';
import moment from 'moment';
import * as types from './mutationTypes';

const mapperErrors = {
  'Metadata is required': 'sso.messages.metadata_is_required',
  'Invalid metadata': 'sso.messages.invalid_metadata',
};

export default {
  initState({ commit }) {
    commit(types.SET_SSO, {
      sso: [],
      sso_default: null,
    });
  },
  clearState({ commit, dispatch }) {
    commit(types.CLEAR_SSO);
    dispatch('team/clearTeams', null, { root: true });
  },
  setSsoSuccess({ commit }, sso) {
    commit(types.SET_SSO, sso);
  },
  async getAll({ rootState, dispatch }) {
    try {
      const response = await SsoService.getAll(rootState.organization.organization.uuid);
      if (response.data.data.sso) {
        dispatch('setSsoSuccess', response.data.data.sso);
      }
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async update({ rootState, state, dispatch }, organization) {
    const valid = await dispatch('validate', organization);
    if (!valid) {
      dispatch('ui/showToastError', i18n.t('team.messages.verify_empty_fields'), { root: true });
      return;
    }
    try {
      const contractExpiration = moment(formatDateTime(organization.contract_expiration))
        .toISOString();
      const data = {
        organization: { ...organization, contract_expiration: contractExpiration },
        sso: state.sso,
      };
      const response = await SsoService.update(rootState.organization.organization.uuid, data);
      if (response.data.data.sso) {
        dispatch('setSsoSuccess', response.data.data.sso);
        dispatch('organization/updateOrganization', response.data.data.organization, { root: true });
      }
      dispatch('ui/showToastSuccess', i18n.t('team.messages.save_sso_success'), { root: true });
    } catch (error) {
      let message = '';

      if (error && error?.response?.data) {
        const mapperError = mapperErrors[error.response.data?.message];
        message = mapperError || message;
      }
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error, message), { root: true });
    }
  },
  async delete({ rootState, dispatch }, ssoUUID) {
    try {
      if (!ssoUUID) {
        return false;
      }
      await SsoService.delete(rootState.organization.organization.uuid, ssoUUID);

      return true;
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });

      return false;
    }
  },
  validate({ state }, organization) {
    let validade = true;

    state.sso.sso.forEach((sso) => {
      if (sso.sso_group_name === null || sso.sso_group_name === '') {
        validade = false;
      }
      if (sso.team_uuid === null || sso.team_uuid === '') {
        validade = false;
      }
    });
    if (organization.sso_active && (state.sso.sso_default === null || state.sso.sso_default === '')) {
      validade = false;
    }
    return validade;
  },
  addGroup({ commit }) {
    commit(types.ADD_GROUP);
  },
  removeGroup({ commit }, index) {
    commit(types.REMOVE_GROUP, index);
  },
  setGroupName({ commit }, { index, name }) {
    commit(types.SET_GROUP_NAME, { index, name });
  },
  setGroupTeam({ commit }, { index, teamUUID }) {
    commit(types.SET_GROUP_TEAM, { index, teamUUID });
  },
  setDefault({ commit }, teamUUID) {
    commit(types.SET_DEFAULT, teamUUID);
  },
};
